import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'ConfirmModal',
})
export default class ConfirmModal extends Vue {
    @Prop()
    title;
    @Prop()
    message;
    confirm() {
        this.$modals.close({ confirmed: true });
    }
    cancel() {
        this.$modals.close();
    }
}
